import * as React from 'react';
import { useCallback } from 'react';

function _regeneratorRuntime() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */

  _regeneratorRuntime = function () {
    return exports;
  };

  var exports = {},
      Op = Object.prototype,
      hasOwn = Op.hasOwnProperty,
      $Symbol = "function" == typeof Symbol ? Symbol : {},
      iteratorSymbol = $Symbol.iterator || "@@iterator",
      asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator",
      toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  function define(obj, key, value) {
    return Object.defineProperty(obj, key, {
      value: value,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), obj[key];
  }

  try {
    define({}, "");
  } catch (err) {
    define = function (obj, key, value) {
      return obj[key] = value;
    };
  }

  function wrap(innerFn, outerFn, self, tryLocsList) {
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator,
        generator = Object.create(protoGenerator.prototype),
        context = new Context(tryLocsList || []);
    return generator._invoke = function (innerFn, self, context) {
      var state = "suspendedStart";
      return function (method, arg) {
        if ("executing" === state) throw new Error("Generator is already running");

        if ("completed" === state) {
          if ("throw" === method) throw arg;
          return doneResult();
        }

        for (context.method = method, context.arg = arg;;) {
          var delegate = context.delegate;

          if (delegate) {
            var delegateResult = maybeInvokeDelegate(delegate, context);

            if (delegateResult) {
              if (delegateResult === ContinueSentinel) continue;
              return delegateResult;
            }
          }

          if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) {
            if ("suspendedStart" === state) throw state = "completed", context.arg;
            context.dispatchException(context.arg);
          } else "return" === context.method && context.abrupt("return", context.arg);
          state = "executing";
          var record = tryCatch(innerFn, self, context);

          if ("normal" === record.type) {
            if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
            return {
              value: record.arg,
              done: context.done
            };
          }

          "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
        }
      };
    }(innerFn, self, context), generator;
  }

  function tryCatch(fn, obj, arg) {
    try {
      return {
        type: "normal",
        arg: fn.call(obj, arg)
      };
    } catch (err) {
      return {
        type: "throw",
        arg: err
      };
    }
  }

  exports.wrap = wrap;
  var ContinueSentinel = {};

  function Generator() {}

  function GeneratorFunction() {}

  function GeneratorFunctionPrototype() {}

  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });
  var getProto = Object.getPrototypeOf,
      NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);

  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function (method) {
      define(prototype, method, function (arg) {
        return this._invoke(method, arg);
      });
    });
  }

  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);

      if ("throw" !== record.type) {
        var result = record.arg,
            value = result.value;
        return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) {
          invoke("next", value, resolve, reject);
        }, function (err) {
          invoke("throw", err, resolve, reject);
        }) : PromiseImpl.resolve(value).then(function (unwrapped) {
          result.value = unwrapped, resolve(result);
        }, function (error) {
          return invoke("throw", error, resolve, reject);
        });
      }

      reject(record.arg);
    }

    var previousPromise;

    this._invoke = function (method, arg) {
      function callInvokeWithMethodAndArg() {
        return new PromiseImpl(function (resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
    };
  }

  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];

    if (undefined === method) {
      if (context.delegate = null, "throw" === context.method) {
        if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel;
        context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);
    if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
    var info = record.arg;
    return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
  }

  function pushTryEntry(locs) {
    var entry = {
      tryLoc: locs[0]
    };
    1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal", delete record.arg, entry.completion = record;
  }

  function Context(tryLocsList) {
    this.tryEntries = [{
      tryLoc: "root"
    }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
  }

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) return iteratorMethod.call(iterable);
      if ("function" == typeof iterable.next) return iterable;

      if (!isNaN(iterable.length)) {
        var i = -1,
            next = function next() {
          for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;

          return next.value = undefined, next.done = !0, next;
        };

        return next.next = next;
      }
    }

    return {
      next: doneResult
    };
  }

  function doneResult() {
    return {
      value: undefined,
      done: !0
    };
  }

  return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) {
    var ctor = "function" == typeof genFun && genFun.constructor;
    return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
  }, exports.mark = function (genFun) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
  }, exports.awrap = function (arg) {
    return {
      __await: arg
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    void 0 === PromiseImpl && (PromiseImpl = Promise);
    var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
    return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) {
      return result.done ? result.value : iter.next();
    });
  }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () {
    return this;
  }), define(Gp, "toString", function () {
    return "[object Generator]";
  }), exports.keys = function (object) {
    var keys = [];

    for (var key in object) keys.push(key);

    return keys.reverse(), function next() {
      for (; keys.length;) {
        var key = keys.pop();
        if (key in object) return next.value = key, next.done = !1, next;
      }

      return next.done = !0, next;
    };
  }, exports.values = values, Context.prototype = {
    constructor: Context,
    reset: function (skipTempReset) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
    },
    stop: function () {
      this.done = !0;
      var rootRecord = this.tryEntries[0].completion;
      if ("throw" === rootRecord.type) throw rootRecord.arg;
      return this.rval;
    },
    dispatchException: function (exception) {
      if (this.done) throw exception;
      var context = this;

      function handle(loc, caught) {
        return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i],
            record = entry.completion;
        if ("root" === entry.tryLoc) return handle("end");

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc"),
              hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
          } else {
            if (!hasFinally) throw new Error("try statement without catch or finally");
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          }
        }
      }
    },
    abrupt: function (type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];

        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
      var record = finallyEntry ? finallyEntry.completion : {};
      return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
    },
    complete: function (record, afterLoc) {
      if ("throw" === record.type) throw record.arg;
      return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
    },
    finish: function (finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
      }
    },
    catch: function (tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];

        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;

          if ("throw" === record.type) {
            var thrown = record.arg;
            resetTryEntry(entry);
          }

          return thrown;
        }
      }

      throw new Error("illegal catch attempt");
    },
    delegateYield: function (iterable, resultName, nextLoc) {
      return this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
    }
  }, exports;
}

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

var getCookie = function getCookie(name) {
  var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
  if (match) return match[2];
};

var GET_CONSENT_BANNER_URL = '/api/cronos/mkt/GetConsentBanner';
var POST_UPDATE_CONSENT_CONFIG_URL = '/api/cronos/mkt/UpdateConsentConfiguration';
var Analytic;

(function (Analytic) {
  Analytic["CLICK"] = "click";
  Analytic["SEEN"] = "seen";
})(Analytic || (Analytic = {}));

var CONSENT_PAGE_URL = '/privacy-settings';
var COOKIE_POLICY_PAGE_URL = '/info/privacy.html#cookies';
var BannerType;

(function (BannerType) {
  BannerType[BannerType["AllFeatures"] = 1] = "AllFeatures";
  BannerType[BannerType["FunctionalOnly"] = 2] = "FunctionalOnly"; // Consent Banner made with functional only feature as concern raised by BHI that Agoda does not provide a list of cookies on FE which may lead to non-compliance.
})(BannerType || (BannerType = {}));

var sendMeasurement = function sendMeasurement(action, messagingClient, origin, cid, isBannerReturn, pageTypeId, bannerType) {
  var measurement = messagingClient.create('measurement', {
    name: "fe.marketing.consent.".concat(action),
    measurement: 1,
    count: 1,
    tags: {
      origin: origin,
      pageTypeId: pageTypeId,
      cid: cid,
      isBannerReturn: isBannerReturn,
      bannerType: bannerType
    }
  });
  messagingClient.send(measurement);
  var messageData = {
    origin: origin,
    pageTypeId: pageTypeId,
    cid: cid,
    isBannerReturn: isBannerReturn
  };
  var message = messagingClient.create("ConsentBannerRequest", messageData);
  messagingClient.send(message);
};
var logError = function logError(message, messagingClient, origin, pageTypeId) {
  var log = messagingClient.create('log', {
    message: "[ConsentBanner]: ".concat(message),
    level: 'error',
    countryOfOrigin: origin,
    callerModuleId: pageTypeId,
    loggerName: "Fe.Messaging.Logger"
  });
  messagingClient.send(log);
};

var moment = require('moment');

var getCronosHeader = function getCronosHeader(context) {
  var result = [];

  if (context.langId) {
    result.push(['AG-Language-Id', context.langId]);
  }

  if (context.langLocale) {
    result.push(['AG-Language-Locale', context.langLocale]);
  }

  return result;
};
var GetConsentBanner = function GetConsentBanner(requestContext, consentMeasurement) {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    var _a, cookieValue, cookieLastUpdate, response, consentBanner;

    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            cookieValue = (_a = getCookie('agoda.consent')) === null || _a === void 0 ? void 0 : _a.split('|');
            cookieLastUpdate = null;

            if (cookieValue && cookieValue.length > 2 && cookieValue[2]) {
              cookieLastUpdate = moment.utc(cookieValue[2]);
              cookieLastUpdate = cookieLastUpdate.add(30, 'minutes');
            }

            if (!(!cookieValue || consentMeasurement.origin.toLowerCase() !== cookieValue[0].toLowerCase() || !(moment.isMoment(cookieLastUpdate) && cookieLastUpdate.isValid()) || cookieLastUpdate.isBefore(moment.utc()))) {
              _context.next = 15;
              break;
            }

            _context.next = 7;
            return fetch(GET_CONSENT_BANNER_URL, {
              headers: getCronosHeader(requestContext)
            });

          case 7:
            response = _context.sent;

            if (consentMeasurement.messagingClient) {
              sendMeasurement('GetConsentBanner', consentMeasurement.messagingClient, consentMeasurement.origin, consentMeasurement.cid, response.status == 200, consentMeasurement.pageTypeId);
            }

            if (!(response.status == 200)) {
              _context.next = 15;
              break;
            }

            _context.next = 12;
            return response.json();

          case 12:
            consentBanner = _context.sent;

            if (consentMeasurement.messagingClient) {
              sendMeasurement('DisplayConsentBanner', consentMeasurement.messagingClient, consentMeasurement.origin, consentMeasurement.cid, true, consentMeasurement.pageTypeId, consentBanner === null || consentBanner === void 0 ? void 0 : consentBanner.bannerType);
            }

            return _context.abrupt("return", consentBanner !== null && consentBanner !== void 0 ? consentBanner : null);

          case 15:
            return _context.abrupt("return", null);

          case 18:
            _context.prev = 18;
            _context.t0 = _context["catch"](0);

            if (consentMeasurement.messagingClient) {
              logError("GetConsentBanner error: ".concat(_context.t0), consentMeasurement.messagingClient, consentMeasurement.origin, consentMeasurement.pageTypeId);
            }

            return _context.abrupt("return", null);

          case 22:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 18]]);
  }));
};

var updateConsentConfiguration = function updateConsentConfiguration(isAccept, setShowBanner, consentMeasurement, bannerType) {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    var subfix;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            subfix = isAccept ? "Accepted" : "Rejected";

            if (consentMeasurement.messagingClient) {
              sendMeasurement("ConsentBanner".concat(subfix), consentMeasurement.messagingClient, consentMeasurement.origin, consentMeasurement.cid, undefined, consentMeasurement.pageTypeId, bannerType);
            }

            _context.next = 5;
            return fetch(POST_UPDATE_CONSENT_CONFIG_URL, {
              method: 'POST',
              body: JSON.stringify({
                acceptAll: isAccept
              }),
              headers: {
                'Content-Type': 'application/json'
              }
            });

          case 5:
            _context.next = 10;
            break;

          case 7:
            _context.prev = 7;
            _context.t0 = _context["catch"](0);

            if (consentMeasurement.messagingClient) {
              logError("updateConsentConfiguration error: ".concat(_context.t0), consentMeasurement.messagingClient, consentMeasurement.origin, consentMeasurement.pageTypeId);
            }

          case 10:
            _context.prev = 10;
            setShowBanner(false);
            return _context.finish(10);

          case 13:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 7, 10, 13]]);
  }));
};

function styleInject(css, ref) {
  if (ref === void 0) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') {
    return;
  }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z$1 = ".ConsentBanner {\n  bottom: 0;\n  position: fixed;\n  z-index: 1010;\n  padding: 13px;\n  background: #F0F3F9;\n  box-shadow: 0px 2px 7px rgba(0, 0, 0, 0.2);\n  border-radius: 5px;\n  display: flex;\n  justify-content: space-between; }\n  @media (max-width: 768px) {\n    .ConsentBanner {\n      display: block;\n      padding: 10px 16px;\n      background: #F7F9FC; } }\n  .ConsentBanner img {\n    width: 30px;\n    height: 30px;\n    border-radius: 8px;\n    display: block; }\n  .ConsentBanner .Text {\n    color: #24262C;\n    width: 77%; }\n    @media (max-width: 768px) {\n      .ConsentBanner .Text {\n        width: auto; } }\n    .ConsentBanner .Text__Title {\n      font-weight: 500;\n      font-size: 16px;\n      line-height: 25px; }\n    .ConsentBanner .Text__Description {\n      font-weight: 376;\n      font-size: 14px;\n      line-height: 16px; }\n  .ConsentBanner .BtnContainer {\n    position: relative;\n    height: 35px;\n    margin: auto;\n    display: flex; }\n    html[dir=rtl] .ConsentBanner .BtnContainer {\n      order: 0; }\n    @media (max-width: 768px) {\n      .ConsentBanner .BtnContainer {\n        height: 6vh;\n        padding: 9px 0px;\n        margin: unset; } }\n    .ConsentBanner .BtnContainer .CookieSettingBtn {\n      height: 30px;\n      color: #3E6CEA;\n      font-weight: 400;\n      border: none;\n      background: none;\n      margin: auto 18px; }\n      @media (max-width: 768px) {\n        .ConsentBanner .BtnContainer .CookieSettingBtn {\n          position: absolute;\n          margin: auto; } }\n    .ConsentBanner .BtnContainer .BtnPair {\n      display: flex;\n      flex-direction: column-reverse;\n      margin: auto;\n      transform: translateY(-16px); }\n      @media (max-width: 768px) {\n        .ConsentBanner .BtnContainer .BtnPair {\n          position: absolute;\n          right: 0;\n          transform: none;\n          display: block; }\n          html[dir=rtl] .ConsentBanner .BtnContainer .BtnPair {\n            left: 0;\n            right: auto; } }\n      .ConsentBanner .BtnContainer .BtnPair__RejectBtn {\n        background: #FFFFFF;\n        border: 1px solid #3E6CEA;\n        border-radius: 16px;\n        width: 84px;\n        height: 30px;\n        color: #3E6CEA;\n        font-weight: 500; }\n        @media (max-width: 768px) {\n          .ConsentBanner .BtnContainer .BtnPair__RejectBtn {\n            margin-right: 7px; } }\n        html[dir=rtl] .ConsentBanner .BtnContainer .BtnPair__RejectBtn {\n          float: left;\n          margin-left: 7px; }\n      .ConsentBanner .BtnContainer .BtnPair__AcceptBtn {\n        width: 84px;\n        height: 30px;\n        background: #3E6CEA;\n        border-radius: 16px;\n        margin-bottom: 6px;\n        color: #FFFFFF;\n        border: 1px solid #3E6CEA;\n        font-weight: 500; }\n";
styleInject(css_248z$1);

var ConsentBannerWithAllFunctions = function ConsentBannerWithAllFunctions(props) {
  var _React$useState = React.useState(true),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      isShowBanner = _React$useState2[0],
      setShowBanner = _React$useState2[1];

  var ref = useCallback(function (el) {
    var _a, _b;

    (_b = (_a = props.consetBannerProps) === null || _a === void 0 ? void 0 : _a.containerRef) === null || _b === void 0 ? void 0 : _b.call(_a, el);
  }, [props.consetBannerProps.containerRef]);
  return isShowBanner && props.consentBannerCmsValue && /*#__PURE__*/React.createElement("div", {
    className: "ConsentBanner",
    style: {
      bottom: props.consetBannerProps.bottomOffset ? "".concat(props.consetBannerProps.bottomOffset, "px") : 0
    },
    "data-element-name": "consent-banner",
    "data-modal-type": "blocking",
    ref: ref
  }, /*#__PURE__*/React.createElement("div", {
    className: "Text"
  }, /*#__PURE__*/React.createElement("img", {
    src: "//cdn0.agoda.net/images/consentbanner/cookie.png"
  }), /*#__PURE__*/React.createElement("div", {
    className: "Text__Title"
  }, props.consentBannerCmsValue.titleText), /*#__PURE__*/React.createElement("div", {
    className: "Text__Description"
  }, props.consentBannerCmsValue.descriptionText, /*#__PURE__*/React.createElement("a", {
    href: COOKIE_POLICY_PAGE_URL
  }, " ", props.consentBannerCmsValue.cookiePolicyText, " "))), /*#__PURE__*/React.createElement("div", {
    className: "BtnContainer"
  }, /*#__PURE__*/React.createElement("button", {
    className: "CookieSettingBtn",
    "data-element-name": "Consent-Banner-See-More-Btn",
    onClick: function onClick() {
      props.consetBannerProps.analyticCallback('Consent-Banner-See-More-Btn', Analytic.CLICK);
      window.location.href = CONSENT_PAGE_URL;
    }
  }, props.consentBannerCmsValue.cookieSettingText), /*#__PURE__*/React.createElement("div", {
    className: "BtnPair"
  }, /*#__PURE__*/React.createElement("button", {
    className: "BtnPair__RejectBtn",
    "data-element-name": "consent-banner-reject-btn",
    onClick: function onClick() {
      updateConsentConfiguration(false, setShowBanner, props.consentBannerMeasurement, props.consentBannerCmsValue.bannerType);
      props.consetBannerProps.analyticCallback('consent-banner-reject-btn', Analytic.CLICK);
    }
  }, props.consentBannerCmsValue.rejectAllText), /*#__PURE__*/React.createElement("button", {
    className: "BtnPair__AcceptBtn",
    "data-element-name": "consent-banner-accept-btn",
    "data-modal-action": "continue",
    onClick: function onClick() {
      updateConsentConfiguration(true, setShowBanner, props.consentBannerMeasurement, props.consentBannerCmsValue.bannerType);
      props.consetBannerProps.analyticCallback('consent-banner-accept-btn', Analytic.CLICK);
    }
  }, props.consentBannerCmsValue.acceptAllText))));
};

var css_248z = ".ConsentBannerFunctionalOnly {\n  bottom: 0;\n  position: fixed;\n  z-index: 1010;\n  padding: 13px;\n  background: #F0F3F9;\n  box-shadow: 0px 2px 7px rgba(0, 0, 0, 0.2);\n  border-radius: 5px;\n  display: flex;\n  justify-content: space-between;\n  width: 100%; }\n  @media (max-width: 768px) {\n    .ConsentBannerFunctionalOnly {\n      display: block;\n      padding: 10px 16px;\n      background: #F7F9FC; } }\n  .ConsentBannerFunctionalOnly img {\n    width: 30px;\n    height: 30px;\n    border-radius: 8px;\n    display: block; }\n  .ConsentBannerFunctionalOnly .Text {\n    color: #24262C;\n    width: 77%; }\n    @media (max-width: 768px) {\n      .ConsentBannerFunctionalOnly .Text {\n        width: auto; } }\n    .ConsentBannerFunctionalOnly .Text__Title {\n      font-weight: 500;\n      font-size: 16px;\n      line-height: 25px; }\n    .ConsentBannerFunctionalOnly .Text__Description {\n      font-weight: 376;\n      font-size: 14px;\n      line-height: 16px; }\n  .ConsentBannerFunctionalOnly .BtnContainer {\n    position: relative;\n    display: flex;\n    justify-content: flex-end;\n    align-items: center; }\n    html[dir=rtl] .ConsentBannerFunctionalOnly .BtnContainer {\n      order: 0; }\n    @media (max-width: 768px) {\n      .ConsentBannerFunctionalOnly .BtnContainer {\n        height: 6vh;\n        padding: 9px 0px;\n        margin: unset;\n        display: flex;\n        justify-content: flex-end; } }\n    .ConsentBannerFunctionalOnly .BtnContainer .BtnPair {\n      display: flex;\n      flex-direction: column-reverse;\n      margin: auto; }\n      @media (max-width: 768px) {\n        .ConsentBannerFunctionalOnly .BtnContainer .BtnPair {\n          position: absolute;\n          right: 0;\n          transform: none;\n          display: block; }\n          html[dir=rtl] .ConsentBannerFunctionalOnly .BtnContainer .BtnPair {\n            left: 0;\n            right: auto; } }\n      .ConsentBannerFunctionalOnly .BtnContainer .BtnPair__RejectBtn {\n        background: #FFFFFF;\n        border: 1px solid #3E6CEA;\n        border-radius: 16px;\n        width: 84px;\n        height: 30px;\n        color: #3E6CEA;\n        font-weight: 500; }\n        @media (max-width: 768px) {\n          .ConsentBannerFunctionalOnly .BtnContainer .BtnPair__RejectBtn {\n            margin-right: 7px; } }\n        html[dir=rtl] .ConsentBannerFunctionalOnly .BtnContainer .BtnPair__RejectBtn {\n          float: left;\n          margin-left: 7px; }\n";
styleInject(css_248z);

var ConsentBannerFunctionalOnly = function ConsentBannerFunctionalOnly(props) {
  var _a;

  var _React$useState = React.useState(true),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      isShowBanner = _React$useState2[0],
      setShowBanner = _React$useState2[1];

  var handleDismiss = useCallback(function () {
    var _a;

    updateConsentConfiguration(false, setShowBanner, props.consentBannerMeasurement, (_a = props.consentBannerCmsValue) === null || _a === void 0 ? void 0 : _a.bannerType);
    props.consetBannerProps.analyticCallback('consent-banner-dismiss-btn', Analytic.CLICK);
  }, [props.consetBannerProps.analyticCallback, props.consentBannerMeasurement, (_a = props.consentBannerCmsValue) === null || _a === void 0 ? void 0 : _a.bannerType, setShowBanner]);
  var ref = useCallback(function (el) {
    var _a, _b;

    (_b = (_a = props.consetBannerProps).containerRef) === null || _b === void 0 ? void 0 : _b.call(_a, el);
  }, [props.consetBannerProps.containerRef]);
  return isShowBanner && props.consentBannerCmsValue && /*#__PURE__*/React.createElement("div", {
    className: "ConsentBannerFunctionalOnly",
    style: {
      bottom: props.consetBannerProps.bottomOffset ? "".concat(props.consetBannerProps.bottomOffset, "px") : 0
    },
    "data-element-name": "consent-banner",
    "data-modal-type": "blocking",
    ref: ref
  }, /*#__PURE__*/React.createElement("div", {
    className: "Text"
  }, /*#__PURE__*/React.createElement("img", {
    src: "//cdn0.agoda.net/images/consentbanner/cookie.png"
  }), /*#__PURE__*/React.createElement("div", {
    className: "Text__Title"
  }, props.consentBannerCmsValue.titleText), /*#__PURE__*/React.createElement("div", {
    className: "Text__Description",
    dangerouslySetInnerHTML: {
      __html: props.consentBannerCmsValue.descriptionText.replace('{0}', "<a href=".concat(COOKIE_POLICY_PAGE_URL, ">").concat(props.consentBannerCmsValue.cookiePolicyText, "</a>"))
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "BtnContainer"
  }, /*#__PURE__*/React.createElement("div", {
    className: "BtnPair"
  }, /*#__PURE__*/React.createElement("button", {
    className: "BtnPair__RejectBtn",
    "data-element-name": "consent-banner-reject-btn",
    "data-modal-action": "continue",
    onClick: handleDismiss
  }, props.consentBannerCmsValue.rejectAllText))));
};

var ConsentBanner = function ConsentBanner(props) {
  var requestContext = {
    langId: props.langId,
    langLocale: props.langLocale
  };
  var consentBannerRequest = {
    origin: props.origin,
    pageTypeId: props.pageTypeId,
    cid: props.cid,
    messagingClient: props.msgClient
  };

  var _React$useState = React.useState({
    consetBannerProps: props,
    consentBannerCmsValue: null,
    consentBannerMeasurement: consentBannerRequest
  }),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      consentBannerFactoryData = _React$useState2[0],
      setConsentBannerFactoryData = _React$useState2[1];

  React.useEffect(function () {
    GetConsentBanner(requestContext, consentBannerRequest).then(function (data) {
      if (data) {
        props.analyticCallback('consent-banner', Analytic.SEEN);
        setConsentBannerFactoryData(_extends(_extends({}, consentBannerFactoryData), {
          consentBannerCmsValue: data
        }));
      }
    });
  }, []);
  React.useEffect(function () {
    setConsentBannerFactoryData(function (prev) {
      return _extends(_extends({}, prev), {
        consetBannerProps: _extends(_extends({}, prev.consetBannerProps), {
          bottomOffset: props.bottomOffset
        })
      });
    });
  }, [props.bottomOffset]);
  React.useEffect(function () {
    setConsentBannerFactoryData(function (prev) {
      return _extends(_extends({}, prev), {
        consetBannerProps: _extends(_extends({}, prev.consetBannerProps), {
          containerRef: props.containerRef
        })
      });
    });
  }, [props.containerRef]);
  return props && consentBannerFactoryData.consentBannerCmsValue && (consentBannerFactoryData.consentBannerCmsValue.bannerType === BannerType.FunctionalOnly ? /*#__PURE__*/React.createElement(ConsentBannerFunctionalOnly, consentBannerFactoryData) : /*#__PURE__*/React.createElement(ConsentBannerWithAllFunctions, consentBannerFactoryData));
};

export { ConsentBanner };
//# sourceMappingURL=index.js.map
